import {NewsCommentsCollectionValueObject} from './NewsCommentsCollectionValueObject.js'
import {NewsCommentsRequestValueObject} from './NewsCommentsRequestValueObject.js'
import {NewsPostCommentRequestValueObject} from './NewsPostCommentRequestValueObject.js'
import {NewsRatingRequestValueObject} from './NewsRatingRequestValueObject.js'
import {NewsRatingValueObject} from './NewsRatingValueObject.js'

export class ReviewsValueObjectsFactory {
  static newsCommentsRequestValueObject = ({articleId, items, pageNumber}) =>
    new NewsCommentsRequestValueObject({
      articleId,
      items,
      pageNumber
    })

  static newsPostCommentRequestValueObject = ({articleId, comment, commentId, userEntity}) => {
    const {userId, token} = userEntity?.toJSON() || {}
    return new NewsPostCommentRequestValueObject({
      articleId,
      comment,
      commentId,
      ...(userId && {userId}),
      ...(token && {token})
    })
  }

  static newsCommentsCollectionValueObject = ({comments}) => new NewsCommentsCollectionValueObject({comments})

  static newsRatingRequestValueObject = ({articleId}) => new NewsRatingRequestValueObject({articleId})

  static newsRatingValueObject = ({rate, ratesCount}) => new NewsRatingValueObject({rate, ratesCount})
}
